const { CallApi } = require("app/_helpers/CallApi/CallApi");

export const getAllCategory = async (filter) => {
  let url = `/global-configuration/category`;

  console.log("filter", filter);

  if (filter) url += "?" + filter;

  return await CallApi(url, "GET");
};

export const getCategoryById = async (id) => {
  let url = "/global-configuration/category/" + id;
  return await CallApi(url, "GET");
};

export const createCategory = async (data) => {
  let url = "/global-configuration/category";
  return await CallApi(url, "POST", data);
};

// export const createByExcel = async (data) => {
//   let url = "/global-configuration/category/excel";
//   return await CallApi(url, "POST", data);
// };

export const updateCategory = async (id, data) => {
  let url = "/global-configuration/category/" + data.id;
  return await CallApi(url, "PUT", data);
};

export const deleteCategory = async (id) => {
  let url = "/global-configuration/category/" + id;
  return await CallApi(url, "DELETE");
};
